var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title',[_vm._v("Liste du seau")]),_c('p',{attrs:{"id":"bucketlist-title"}},[_vm._v("Liste du seau")]),_c('div',{attrs:{"id":"tasks"}},[_c('InputField'),_c('Tasks')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }